//import {fetchUtils} from 'react-admin';
import {
  MASBRAN_API_LOGIN,
  ROUTES_LOGIN,
  SECTION_LOGIN,
  SESSION_APP_CONTEXT_STORAGE_KEY,
  SESSION_PERMISSIONS_STORAGE_KEY,
  SESSION_TOKEN_STORAGE_KEY,
} from "./utils/constants";
import { _getSessionToken } from "./utils/utils";
import {
  setIdCrmAction,
  setIdLoginAction,
  setIdUserAction,
  setTenantAction,
  setUserTypeAction,
  setSearchTabAction,
} from "./reducers";
import { store } from "./store";

let log = false;

export const authProviderHttpClient = (url, options = {}) => {
  if (!options.headers) {
    //options.headers = new Headers({Accept: 'application/json'});
  }
  // add your own headers here
  //options.headers.set('Masbran-Session-Token', _getSessionToken());
  //options.headers.set('X-App-Context', JSON.stringify(_getAppContext()));
  // descomentar si hay relaciones padre-hijo con pestañas
  //var hashPos = window.location.href.indexOf("#");
  //if ( hashPos >= 0 ) {
  //  options.headers.set("X-Page-Context", window.location.href.substr(hashPos+1));
  //}
  //return fetchUtils.fetchJson(url, options);
};

///////////////////////////////////////////////////////////////////////////////
// informacion de estado privada

let _loginPermissionsCache = null;

function _setSessionToken(sessionToken) {
  if (sessionToken) {
    sessionStorage.setItem(SESSION_TOKEN_STORAGE_KEY, sessionToken);
  } else {
    sessionStorage.removeItem(SESSION_TOKEN_STORAGE_KEY);
  }
}

function _setAppContext(appContext) {
  if (appContext) {
    sessionStorage.setItem(SESSION_APP_CONTEXT_STORAGE_KEY, JSON.stringify(appContext));
  } else {
    sessionStorage.removeItem(SESSION_APP_CONTEXT_STORAGE_KEY);
  }
}

function _setSessionPermissions(sessionPermissions) {
  if (sessionPermissions) {
    sessionStorage.setItem(SESSION_PERMISSIONS_STORAGE_KEY, JSON.stringify(sessionPermissions));
  } else {
    sessionStorage.removeItem(SESSION_PERMISSIONS_STORAGE_KEY);
  }
}

// devuelve siempre un objeto
function _getAppContext() {
  const appContextString = sessionStorage.getItem(SESSION_APP_CONTEXT_STORAGE_KEY);
  try {
    const ret = appContextString ? JSON.parse(appContextString) : {};
    return typeof ret === "object" ? ret : {};
  } catch (e) {
    console.log("************************ vacio appContext por error en su formato json: " + appContextString);
    _setAppContext(null);
    return {};
  }
}

function _clearSession() {
  localStorage.clear();

  store.dispatch(setIdCrmAction(""));
  store.dispatch(setIdUserAction(""));
  store.dispatch(setTenantAction(""));
  store.dispatch(setIdLoginAction(""));
  store.dispatch(setSearchTabAction(false));
  store.dispatch(setUserTypeAction(null));

  _setSessionPermissions(null);
  _setSessionToken(null);
  _setAppContext(null);
  _loginPermissionsCache = null;
}

///////////////////////////////////////////////////////////////////////////////
// para usarse desde PersonalizedLoginForm.js : la forma mas facil de pedir el pin de doble factor es hacerlo desde el formulario

export function lfLoginRequest(params) {
  return _apiRequest("POST", MASBRAN_API_LOGIN, params);
}

///////////////////////////////////////////////////////////////////////////////

function _clearSessionOnError(err, logTxt) {
  // error nuestro controlado - no queremos que aparezca
  if (err === "/auth-api/masbran/check: Unauthorized") {
    if (log)
      console.log(
        "********************************* AUTH CHECK KAO /auth-api/masbran/check: Unauthorized ********************************",
      );
    err = null;
  }
  // logueamos solo cuando sea un error no controlado (los nuestros son Promise.reject())
  if (log && err)
    console.log(
      "********************************* AUTH %o BORRANDO SESION POR ERROR %o ********************************",
      logTxt,
      err,
    );
  _clearSession();
  return Promise.reject(err);
}

export default {
  login: (loginRes) => {
    if (log) console.log("********************************* AUTH LOGIN %o ********************************", loginRes);
    return _handleLoginRes(loginRes).catch((err) => _clearSessionOnError(err, "LOGIN"));
  },

  logout: (params) => {
    if (log)
      console.log(
        "********************************* AUTH LOGOUT token %o params %o ********************************",
        _getSessionToken(),
        params,
      );
    let logoutSessionToken = _getSessionToken();
    if (logoutSessionToken == null) {
      if (log)
        console.log("********************************* AUTH LOGOUT OK token null ********************************");
      _clearSession();
      return Promise.resolve();
    }
    return (
      _apiRequest("GET", "/public/auth-api/masbran/logout", null, logoutSessionToken)
        // la devolucion de logout cambia de pagina - devolvemos vacio
        .then(() => {
          console.log("***************************** AUTH LOGOUT OK token %o", logoutSessionToken);
          _clearSession();
          return Promise.resolve();
        })
        // si devolvemos un error no hace el logout y se queda mal la aplicacion - mejor no devolverlo
        .catch((error) => {
          console.log("***************************** AUTH LOGOUT KAO token %o error %o", logoutSessionToken, error);
          _clearSession();
          return Promise.resolve();
        })
    );
  },

  // llamado durante la navegacion y al entrar en la pagina
  checkAuth: (params) => {
    if (log)
      console.log(
        "********************************* AUTH CHECK token %o appContext %o permissionsCache %o params %o ********************************",
        _getSessionToken(),
        _getAppContext(),
        _loginPermissionsCache,
        params,
      );
    // se esta cargando la pagina, intentamos obtener un token de sso
    if (_getSessionToken() == null) {
      return _apiRequest("GET", "/public/auth-api/masbran/sso-check")
        .then((ssoCheckRes) => _handleSsoCheckRes(ssoCheckRes))
        .catch((err) => _clearSessionOnError(err, "CHECK SSO"));
    }
    // revisamos el token que tenemos en el storage
    return _apiRequest("GET", "/auth-api/masbran/check")
      .then(() => _getLoginPermissions("CHECK"))
      .catch((err) => _clearSessionOnError(err, "CHECK"));
  },

  // llamado cuando el dataProvider devuelve un error
  checkError: (error) => {
    if (log)
      console.log(
        "********************************* AUTH ERROR token %o appContext %o permissionsCache %o error %o ********************************",
        _getSessionToken(),
        _getAppContext(),
        _loginPermissionsCache,
        error,
      );
    if (_getSessionToken() == null) {
      if (log)
        console.log(
          "********************************* AUTH ERROR sin token, espero a que check haga su trabajo ********************************",
        );
      // alternativa kao porque deja de llamarse a checkError una vez logueado: return new Promise(resolve => setTimeout(() => Promise.reject(), 10000));
      // Promise.resolve() es peor porque muestra el error "Unauthorized"
      return Promise.reject();
    }
    return error.status === 401 ? Promise.reject() : Promise.resolve();
  },

  // llamado en el render de las paginas
  getPermissions: (params) => {
    if (log)
      console.log(
        "********************************* AUTH PERMISSIONS token %o appContext %o permissionsCache %o params %o ********************************",
        _getSessionToken(),
        _getAppContext(),
        _loginPermissionsCache,
        params,
      );
    if (_getSessionToken() == null) {
      if (log)
        console.log(
          "********************************* AUTH PERMISSIONS sin token, espero a que check haga su trabajo ********************************",
        );
      // alternativa no puesta por si causa inestabilidad como con checkError: return new Promise(resolve => setTimeout(() => Promise.reject(), 10000));
      // Promise.resolve(null) es peor porque es posible que una pagina de un error por permissions null
      return Promise.reject();
    }
    return _getLoginPermissions("PERMISSIONS").catch((err) => _clearSessionOnError(err, "PERMISSIONS"));
  },
};

///////////////////////////////////////////////////////////////////////////////

const _request = ({ bodyObj, opts, url }) => {
  if (bodyObj != null) opts.body = JSON.stringify(bodyObj);
  return fetch(new Request(url, opts)).then((res) => {
    if (res.ok && res.status !== 204) {
      return res.json();
    }
    if (!res.ok) {
      return res.json().then((json) =>
        Promise.reject({
          code: res.status,
          message: json?.loginPhaseOut?.message || `${url}: ${res.statusText}`,
        }),
      );
    }
  });
};

function _apiRequest(method, url, bodyObj = null, sessionToken = _getSessionToken()) {
  /*
    Masbran-Brand-Id and MasBran-Tenant-Code are hardcoded to euskaltel brands as administrative as all admin users
    login using K brand. In case this ever change it should be updated with value const brandId = store?.getState().brand;
     */
  // para Masbran-Session-Token en cabecera
  let opts = {
    method,
    headers: new Headers({
      "Content-Type": "application/json",
      "MasBran-Brand-Id": "K",
      "MasBran-Tenant-Code": "euskaltel",
      "Masbran-Session-Token": sessionToken,
    }),
  };
  // para cookie:
  // let opts = { method, credentials: 'same-origin', headers: new Headers(
  //   { 'Content-Type': 'application/json'},
  // )}

  return _request({ bodyObj, opts, url });
}

///////////////////////////////////////////////////////////////////////////////

function _handleLoginRes(loginRes) {
  if (loginRes.sessionToken === null) {
    // damos mensaje clave incorrecta
    _clearSession();
    let msg = loginRes.message === undefined || loginRes.message === null ? "ra.auth.sign_in_error" : loginRes.message;
    if (log)
      console.log("********************************* FIN AUTH LOGIN KAO ******************************** msg %o", msg);
    return Promise.reject(msg);
  }
  _setSessionToken(loginRes.sessionToken);
  _loginPermissionsCache = null;
  // a partir de aqui es igual que el check
  return _getLoginPermissions("LOGIN");
}

///////////////////////////////////////////////////////////////////////////////

function _handleSsoCheckRes(ssoCheckRes) {
  if (ssoCheckRes.sessionToken !== null) {
    if (log)
      console.log(
        "********************************* CHECK SSO RECIBIDO TOKEN SSO ********************************",
        ssoCheckRes.sessionToken,
      );
    _setSessionToken(ssoCheckRes.sessionToken);
    return _getLoginPermissions("CHECK SSO");
  } else if (window.location.hash.split("/")[1] !== SECTION_LOGIN) {
    window.location.href = "/public/masbran#" + ROUTES_LOGIN;
  }
  if (log)
    console.log(
      "********************************* FIN CHECK SSO SIN SESION SSO ********************************",
      ssoCheckRes,
    );
  return Promise.reject();
}

///////////////////////////////////////////////////////////////////////////////

function _getLoginPermissions(logTxt) {
  // ya tenemos _loginPermissionsCache - no hace falta pedirlos
  if (_loginPermissionsCache != null) {
    if (log)
      console.log(
        "********************************* FIN AUTH %o OK devolviendo _loginPermissionsCache ******************************** token %o appContext %o permissionsCache %o ********************************",
        logTxt,
        _getSessionToken(),
        _getAppContext(),
        _loginPermissionsCache,
      );
    return Promise.resolve(_loginPermissionsCache);
  }
  const sessionToken = _getSessionToken(); // por si hay alguna probabilidad de mezclar sesiones, para evitarla

  return _apiRequest("POST", "/api/masbran/login-permissions", _getAppContext(), sessionToken).then((permRes) => {
    _setSessionPermissions(permRes);
    _setSessionToken(sessionToken);
    _setAppContext(permRes.appContext);
    permRes["modo"] = _modo(permRes);
    _loginPermissionsCache = permRes;
    if (log)
      console.log(
        "********************************* FIN AUTH %o OK NUEVA ******************************** token %o appContext %o permissionsCache %o ********************************",
        logTxt,
        _getSessionToken(),
        _getAppContext(),
        _loginPermissionsCache,
      );
    return Promise.resolve(_loginPermissionsCache);
  });
}

///////////////////////////////////////////////////////////////////////////////
// devuelve el modo de visualizacion, usado de momento solo en los menus
// "actual" con lo que ve un usuario en produccion, "alfa" con todo incluido el trabajo en curso, "nuevo" para hacer manuales quitando menus viejos y sin alfa
// "actual" por defecto en produccion, "alfa" en integración y preproducción

function _getModoPorDefecto() {
  // segun el proyecto, puede ser comodo "alfa" en integracion chequeando loginPermissions.environment
  // return loginPermissions.environment === "INT" ? "alfa" : "actual";
  // o puede ser "actual" en los tres entornos
  return "actual";
}

function _modo(loginPermissions) {
  const modoDefecto = _getModoPorDefecto(loginPermissions);
  const urlParams = new URLSearchParams(window.location.search);
  const modoParam = urlParams.get("modo");
  const validModes = ["actual", "alfa", "nuevo"];
  if (!modoParam) {
    return modoDefecto;
  }
  if (modoParam && !validModes.includes(modoParam)) {
    console.log("*************** error, parametro modo no es uno de los validos: %o", modoParam);
    return modoDefecto;
  }
  console.log("**** cambiando modo por parametro de url desde " + modoDefecto + " a " + modoParam);
  return modoParam;
}

///////////////////////////////////////////////////////////////////////////////
// check logout con timer - ya decidiremos si lo mantenemos o quitamos - de momento puede venir bien para debuguear
// puede servir tambien para mantener la sesion viva mientras la ventana este abierta

const _checkStillLoggedInActive = false;
const _checkStillLoggedInTimerMillis = 5000;

function _checkStillLoggedIn() {
  if (_getSessionToken() !== null) {
    if (log) console.log("********* _checkStillLoggedIn  token %o", _getSessionToken());
    _apiRequest("GET", "/auth-api/masbran/check").catch(() => {
      console.log("************** detectado logout - recargando pagina");
      window.location.reload(false);
      return Promise.resolve();
    });
    // en error no deslogueo - sera problema de comunicaciones
  }
}

if (_checkStillLoggedInActive) {
  if (log) console.log("********* setInterval _checkStillLoggedIn");
  setInterval(_checkStillLoggedIn, _checkStillLoggedInTimerMillis);
}

///////////////////////////////////////////////////////////////////////////////
// acceso a la información de permissions (_loginPermissionsCache) a traves de estas funciones
// chequeos de los permisos e informacion de configuracion

// de momento no tenemos permisos

/*
export function presentationArea(permissions) {
  return ((permissions || {}).appContext || {}).presentationArea
}

export function hasFeature(permissions, feature) {
  return permissions && permissions.rpvFeatures.includes(feature)
}

export function isGodRole(permissions) {
  return permissions && permissions.securityRole === "GOD"
}

export function isUserRole(permissions) {
  return permissions && permissions.securityRole === "USER"
}

export function presentationInfo(permissions) {
  return (permissions || {}).presentationInfo
}
*/

// para los modos

export function mostrarActual(permissions) {
  return permissions && permissions.modo !== "nuevo";
}

export function mostrarAlfa(permissions) {
  return permissions && permissions.modo === "alfa";
}

export function mostrarNuevo(permissions) {
  return permissions && (permissions.modo === "alfa" || permissions.modo === "nuevo");
}

///////////////////////////////////////////////////////////////////////////////
// cambio del contexto de aplicacion - de momento no tenemos

/*
export function changeAppContextToRpvAdmin(idRpv) {
  var appContext = {"presentationArea": "ADMIN_AREA", "areaContextEntityId": idRpv} 
  _setAppContext(appContext)
  // quiza tambien cambiar la ruta #/... de la url
  window.location.reload()
}

export function changeAppContextToGod() {
  var appContext = {"presentationArea": "GOD_AREA", "areaContextEntityId": null} 
  _setAppContext(appContext)
  // quiza tambien cambiar la ruta #/... de la url
  window.location.reload()
}
*/

///////////////////////////////////////////////////////////////////////////////
